import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { TruncatedText } from '../TruncatedText';
import type { SellerBriefResponse } from '../../../types/SellerBriefResponse';
import { NeedTypeTags } from '../NeedTypeTags';

interface GeneratedContentProps {
  generatedContent: SellerBriefResponse['content']['generatedContent'];
  needType?: SellerBriefResponse['needType'];
  needTypeDetails?: SellerBriefResponse['needTypeDetails'];
}

export const GeneratedContent: React.FC<GeneratedContentProps> = ({ generatedContent, needType, needTypeDetails }) => {
  const isNeedTypeSpecified = needType || needTypeDetails?.ongoingWorkPotential;
  return (
    <>
      {generatedContent?.map(({ title, content }) => (
        <Stack key={title} direction="column" gap={title === 'Overview' ? '4' : '2'}>
          <Heading size="h_xxs">{title}</Heading>
          {title === 'Overview' && isNeedTypeSpecified && (
            <NeedTypeTags needType={needType} needTypeDetails={needTypeDetails} />
          )}
          <TruncatedText text={content} linesToTruncate="FIVE" />
        </Stack>
      ))}
    </>
  );
};
